module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_abkhazia-27a7d2158a3478a7086d1ed022b1cc47.png";